<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="sass">
  @import ./assets/style/style
</style>

<script>
  import { auth } from '@/db'
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['userDoc'])
    },
    methods: {
      ...mapMutations(['USER_SIGNED_IN'])
    },
    mounted () {
      auth.onAuthStateChanged(user => {
        if (user)
          this.USER_SIGNED_IN(user)
        // this.userDoc.get().then(doc => console.log(doc.data()))
      })

    }
  }
</script>
